"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepNavigation = void 0;
const react_1 = require("@thesisedu/react");
const icons_1 = require("@thesisedu/react/icons");
const react_2 = __importDefault(require("react"));
const getCanGoBack_1 = require("./getCanGoBack");
const Context_1 = require("../Context");
function StepNavigation({ onUpdateStep, disabled, message, noNext, loading: _loading, }) {
    const { currentStepIndex, steps } = (0, Context_1.useTourContext)(true);
    const [stateLoading, setLoading] = react_2.default.useState(false);
    const canGoBack = (0, getCanGoBack_1.getCanGoBack)(currentStepIndex, steps);
    const canGoForward = currentStepIndex < steps.length - 1;
    const loading = _loading || stateLoading;
    return (react_2.default.createElement(BottomWrapper, null,
        react_2.default.createElement(BottomContainer, null,
            canGoBack ? (react_2.default.createElement(react_2.default.Fragment, null,
                react_2.default.createElement(react_1.Reset.Button, { onClick: e => {
                        e.preventDefault();
                        onUpdateStep(-1);
                    } },
                    react_2.default.createElement(icons_1.ArrowLeft, null)),
                react_2.default.createElement(react_1.Space, null))) : null,
            message ? (react_2.default.createElement(MessageContainer, { useDiv: true, color: '@text-color-secondary' }, typeof message === 'string' ? react_2.default.createElement(react_1.Markdown, { children: message, inline: true }) : message)) : null),
        canGoForward && !noNext ? (react_2.default.createElement(NextButton, { onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                e.preventDefault();
                setLoading(true);
                yield onUpdateStep(1);
                setLoading(false);
            }), disabled: !!disabled || loading }, loading ? react_2.default.createElement(react_1.LoadingIndicator, null) : react_2.default.createElement(icons_1.ArrowRight, null))) : !canGoForward && !noNext ? (react_2.default.createElement(NextButton, { onClick: e => {
                e.preventDefault();
                onUpdateStep(1);
            }, disabled: !!disabled, style: { width: 'auto' }, withText: true },
            react_2.default.createElement(icons_1.Check, null),
            "\u00A0\u00A0",
            react_2.default.createElement(react_1.Body, null, "Finish"))) : null));
}
exports.StepNavigation = StepNavigation;
const BottomWrapper = react_1.styled.div `
  display: flex;
  flex-direction: row;
  align-items: stretch;
`;
const BottomContainer = react_1.styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: ${props => props.theme['@size-xs']};
  background: ${props => props.theme['@gray-1']};
  padding: ${props => props.theme['@size-xs']} ${props => props.theme['@size-s']};
  min-height: 40px;
`;
const NextButton = (0, react_1.styled)(react_1.Reset.Button) `
  background: ${props => props.theme['@primary-color']};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  padding: ${props => (props.withText ? `0 ${props.theme['@size-s']}` : '0')};
  color: ${props => props.theme['@gray-0']};
  font-size: ${props => props.theme['@size-m']};
  transition:
    background 0.1s linear,
    color 0.1s linear;
  &:disabled {
    background: ${props => props.theme['@gray-3']};
    color: ${props => props.theme['@gray-5']};
    cursor: default;
  }
`;
const MessageContainer = (0, react_1.styled)(react_1.BodySmall) `
  display: flex;
  align-items: center;
  gap: ${props => props.theme['@size-xxs']};
`;
//# sourceMappingURL=StepNavigation.js.map